import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../css/common.css';
import '../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function Sweden() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Sweden') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [operator, setOperator] = useState('');
    const [accNum, setAccNum] = useState('');
    const [mobNum, setMobNum] = useState('');
    const [operatorCode, setOperatorCode] = useState('');
    const [address, setAddress] = useState('');

    const [companyName, setCompanyName] = useState('');
    const [contactName, setContactName] = useState('');
    const [city, setCity] = useState('');
    const [vatNum, setVatNum] = useState('');
    const [regNum, setRegNum] = useState('');
    const [clientAddress, setClientAddress] = useState('');
    const [state, setState] = useState('');
    const [zip, setZip] = useState('');
    const [dateSign, setDateSign] = useState('');

    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        const JSONDATA = form;

        setTableDataSingle(JSONDATA?.country?.numberDetails?.Single_Number?.table ?? '');
        setTableDataRange(JSONDATA?.country?.numberDetails?.Number_Range?.table ?? '');

        setOperator(JSONDATA?.country?.operatorDetails?.Name ?? '');
        setAddress(JSONDATA?.country?.operatorDetails?.Address ?? '');
        setAccNum(JSONDATA?.country?.operatorDetails?.Account_Number ?? '');
        setMobNum(JSONDATA?.country?.operatorDetails?.MobNum ?? '');
        setOperatorCode(JSONDATA?.country?.operatorDetails?.OperatorCode ?? '');
        document.querySelector('#operator').value = JSONDATA?.country?.operatorDetails?.Name ?? '';
        document.querySelector('#address').value = JSONDATA?.country?.operatorDetails?.Address ?? '';
        document.querySelector('#accNum').value = JSONDATA?.country?.operatorDetails?.Account_Number ?? '';
        document.querySelector('#mobNum').value = JSONDATA?.country?.operatorDetails?.MobNum ?? '';
        document.querySelector('#operatorCode').value = JSONDATA?.country?.operatorDetails?.OperatorCode ?? '';

        setCompanyName(JSONDATA?.country?.clientDetails?.Company_Name ?? '');
        setContactName(JSONDATA?.country?.clientDetails?.Contact_Name ?? '');
        setVatNum(JSONDATA?.country?.clientDetails?.VatNum ?? '');
        setRegNum(JSONDATA?.country?.clientDetails?.RegNum ?? '');
        setClientAddress(JSONDATA?.country?.clientDetails?.Address ?? '');
        setCity(JSONDATA?.country?.clientDetails?.City ?? '');
        setState(JSONDATA?.country?.clientDetails?.State ?? '');
        setZip(JSONDATA?.country?.clientDetails?.Zip ?? '');
        setDateSign(JSONDATA?.country?.clientDetails?.DateSign ?? '');
        document.querySelector('#companyName').value = JSONDATA?.country?.clientDetails?.Company_Name ?? '';
        document.querySelector('#contactName').value = JSONDATA?.country?.clientDetails?.Contact_Name ?? '';
        document.querySelector('#vatNum').value = JSONDATA?.country?.clientDetails?.VatNum ?? '';
        document.querySelector('#regNum').value = JSONDATA?.country?.clientDetails?.RegNum ?? '';
        document.querySelector('#clientAddress').value = JSONDATA?.country?.clientDetails?.Address ?? '';
        document.querySelector('#city').value = JSONDATA?.country?.clientDetails?.City ?? '';
        document.querySelector('#state').value = JSONDATA?.country?.clientDetails?.State ?? '';
        document.querySelector('#zip').value = JSONDATA?.country?.clientDetails?.Zip ?? '';
        document.querySelector('#dateSign').value = JSONDATA?.country?.clientDetails?.DateSign ?? '';
    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (Single)--------------------------------------//

    const [tableDataSingle, setTableDataSingle] = useState([
        { id: Date.now(), num: '', numTypeSingle: '' }
    ]);

    useEffect(() => {
        setTableDataSingle(prevData =>
            prevData.map(row => {
                if (row.num && !row.numTypeSingle) {
                    // If a number exists but numTypeSingle is empty, mark validation as false
                    setValidationStates(prev => ({
                        ...prev,
                        [`numTypeSingle-${row.id}`]: false,
                    }));
                } else {
                    // Otherwise, mark it as valid
                    setValidationStates(prev => ({
                        ...prev,
                        [`numTypeSingle-${row.id}`]: true,
                    }));
                }
                return row;
            })
        );
    }, [tableDataSingle]); // Runs whenever tableDataSingle updates

    const addRow_single = () => {
        setTableDataSingle([...tableDataSingle, { id: Date.now(), num: '', numTypeSingle: '' }]);
    };

    const removeRow_single = (id) => {
        setTableDataSingle(tableDataSingle.filter(row => row.id !== id));
    };

    const handleChange_tableSingle = (id, key, value) => {
        const updatedData = tableDataSingle.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataSingle(updatedData);
    };

    //--------------------------------table declaration (Number Range)--------------------------------------//

    const [tableDataRange, setTableDataRange] = useState([{ id: Date.now(), sNumber: '', eNumber: '', numTypeRange: '' }]);

    useEffect(() => {
        // Check if any number exists in the range table
        setTableDataRange(prevData =>
            prevData.map(row => {
                const hasNumbers = row.sNumber || row.eNumber;
                if (hasNumbers && !row.numTypeRange) {
                    setValidationStates(prev => ({
                        ...prev,
                        [`numTypeRange-${row.id}`]: false,
                    }));
                } else {
                    setValidationStates(prev => ({
                        ...prev,
                        [`numTypeRange-${row.id}`]: true,
                    }));
                }
                return row;
            })
        );
    }, [tableDataRange]); // Runs when tableDataRange changes


    //adding a row
    const addRow_range = () => {
        setTableDataRange([...tableDataRange, { id: Date.now(), sNumber: '', eNumber: '', numTypeRange: '' }]);
    };

    //removing a row
    const removeRow_range = (id) => {
        setTableDataRange(tableDataRange.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableRange = (id, key, value) => {
        const updatedData = tableDataRange.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataRange(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Display the file name
        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            // Check if headers match
            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            // Read actual data from row 6 onwards
            const dataRows = jsonData.slice(1);

            // Extract relevant data for tableDataRange (first two columns: start & end number)
            const formattedDataRange = dataRows.map((row, index) => ({
                id: index + 1,
                sNumber: row[0] ? row[0].toString() : '', // First column (start number)
                eNumber: row[1] ? row[1].toString() : '', // Second column (end number)
                numTypeRange: '', // Empty by default
            }));

            // Set the table data for number range
            setTableDataRange(formattedDataRange);

            // Trigger validation for each row after setting data (similar to previous logic)
            formattedDataRange.forEach(row => {
                const startValue = row.sNumber;
                const endValue = row.eNumber;

                // Validate rangeStart (9-11 digits)
                if (startValue !== '' && !/^\d{9,11}$/.test(startValue)) {
                    setValidationStates(prev => ({
                        ...prev,
                        [`startNumber-${row.id}`]: false,
                    }));
                } else {
                    setValidationStates(prev => ({
                        ...prev,
                        [`startNumber-${row.id}`]: true,
                    }));
                }

                // Validate rangeStop (9-11 digits)
                if (endValue !== '' && !/^\d{9,11}$/.test(endValue)) {
                    setValidationStates(prev => ({
                        ...prev,
                        [`endNumber-${row.id}`]: false,
                    }));
                } else {
                    setValidationStates(prev => ({
                        ...prev,
                        [`endNumber-${row.id}`]: true,
                    }));
                }

                // Check if end range is greater than or equal to start range
                // if (startValue && endValue && parseInt(endValue, 10) < parseInt(startValue, 10)) {
                //     setValidationStates(prev => ({
                //         ...prev,
                //         [`startNumber-${row.id}`]: false,
                //         [`endNumber-${row.id}`]: false,
                //     }));
                // }

                // Validate number type (if range exists)
                if ((startValue || endValue) && row.numTypeRange === '') {
                    setValidationStates(prev => ({
                        ...prev,
                        [`numTypeRange-${row.id}`]: false,
                    }));
                }
            });
        };
        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        // Clear the uploaded file name state
        setUploadedFileName('');

        // Reset the file input field value to clear the selected file
        fileInputRef.current.value = '';

        // Clear the table data by setting it to an empty array
        setTableDataRange([]);

        // Optionally clear the table data for 'Number Range' table
        setTableDataRange([]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };


    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Sweden",

            "numberDetails": {
                "Single_Number": {
                    "table": tableDataSingle
                },
                "Number_Range": {
                    "table": tableDataRange
                }
            },

            "operatorDetails": {
                "Name": operator,
                "Address": address,
                "Account_Number": accNum,
                "MobNum": mobNum,
                "OperatorCode": operatorCode
            },

            "clientDetails": {
                "Company_Name": companyName,
                "Contact_Name": contactName,
                "VatNum": vatNum,
                "RegNum": regNum,
                "Address": clientAddress,
                "City": city,
                "State": state,
                "Zip": zip,
                "DateSign": dateSign
            },
        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);
    //console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {
        let validationErrors = {};

        // Iterate through each row in tableDataSingle to validate individually
        tableDataSingle.forEach(row => {
            if (row.num && !row.numTypeSingle) {
                validationErrors[`numTypeSingle-${row.id}`] = 'Number Type is required for this row when a number is entered.';
            }
        });

        // Ensure both Start Number and End Number are provided in Range Table
        tableDataRange.forEach(row => {
            if (row.sNumber && !row.eNumber) {
                validationErrors[`endNumber-${row.id}`] = 'End Number is required if Start Number is provided.';
            }
            if (!row.sNumber && row.eNumber) {
                validationErrors[`startNumber-${row.id}`] = 'Start Number is required if End Number is provided.';
            }
        });

        // Validate numTypeRange for rows with numbers in the range table
        tableDataRange.forEach(row => {
            if ((row.sNumber || row.eNumber) && !row.numTypeRange) {
                validationErrors[`numTypeRange-${row.id}`] = 'Number Type is required for this row when numbers are entered.';
            }
        });

        if (!companyName) {
            validationErrors.companyName = 'Please fill in Company Name';
        }
        if (!vatNum) {
            validationErrors.vatNum = 'Please fill in VAT Number';
        }
        if (!clientAddress) {
            validationErrors.clientAddress = "Please fill in Client's Address";
        }
        if (!city) {
            validationErrors.city = 'Please fill in City';
        }
        // if (!state) {
        //     validationErrors.state = 'Please fill in State';
        // }
        if (!zip) {
            validationErrors.zip = 'Please fill in Zip';
        }
        // if (!dateSign) {
        //     validationErrors.dateSign = 'Please fill in Date of Signature';
        // }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            // Show the first error message and scroll to the field if it exists
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            const firstErrorElement = document.getElementById(firstErrorKey);

            if (firstErrorElement) {
                firstErrorElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            } else {
                console.error(`Element with ID ${firstErrorKey} not found.`);
                toast.error("An error occurred while scrolling to the invalid field.");
            }

            toast.error(firstError);
            return;
        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys}`);
            const elem = document.getElementById(falseKeys[0]);
            if (elem) {
                elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            } else {
                console.error(`Element with ID ${falseKeys[0]} not found.`);
            }
            return;
        }

        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = accNum + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    // ----------------------------------------------SAVE--------------------------------------------------//

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <p><strong>Mandatory fields are marked by *</strong></p>

                <p>As the end user subscriber and owner, I designate Orange Business Services, hereafter, <strong>Orange Business Sweden</strong> AB, <strong>Sundbybergsvägen 1, 171 73 Solna</strong>, to act as my agent in changing the Responsible Organization & import each of the telephone number(s) specified on this form. </p>

                <h2 className='heading'>Number Details</h2> <br></br>

                <Container>

                    <h4 className='text-decoration-underline'>Single number</h4> <br></br>

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Single Number</th>
                                <th>Number Type</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableDataSingle.map(row => (
                                <tr key={row.id}>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`number-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`number-${row.id}`}
                                            value={row.num}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_tableSingle(row.id, 'num', value);

                                                // Immediate validation feedback for 10-12 digits only when not empty
                                                if (value !== '' && !/^\d{9,11}$/.test(value)) {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`number-${row.id}`] === false && row.num !== '' ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur for 9-11 digits only when not empty
                                                if (row.num !== '' && !/^\d{9,11}$/.test(row.num)) {
                                                    toast.error('Number must be exactly 9-11 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `number-${row.id}` && (
                                            <div className="hover-description">
                                                Add single numbers if any
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        <select
                                            id={`numTypeSingle-${row.id}`}
                                            value={row.numTypeSingle}
                                            onChange={(e) => handleChange_tableSingle(row.id, 'numTypeSingle', e.target.value)}
                                            className={`inputbox ${validationStates[`numTypeSingle-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                if (row.num && !row.numTypeSingle) {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`numTypeSingle-${row.id}`]: false,
                                                    }));
                                                    toast.error('Number Type is required when number is entered.');
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`numTypeSingle-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                        >
                                            <option value=""></option>
                                            <option value="Geographical">Geographical</option>
                                            <option value="Nomadic">Nomadic</option>
                                        </select>
                                    </td>

                                    <td>
                                        {tableDataSingle.length > 1 && (
                                            <button onClick={() => removeRow_single(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <button onClick={addRow_single}>Add Row</button>

                    <br></br>

                </Container>

                <br></br>

                <Container>

                    <h4 className='text-decoration-underline'>Number Range</h4> <br></br>

                    <Row>
                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove
                                </button>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {uploadedFileName && (
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                    <p style={{ marginRight: '10px' }}>Uploaded File: {uploadedFileName}</p>
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />
                    <p>The template is the same used for the btd portability request.</p>
                    <br />


                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Number range start</th>
                                <th>Number range end</th>
                                <th>Number Type</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {tableDataRange.map(row => (
                                <tr key={row.id}>
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`startNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`startNumber-${row.id}`}
                                            value={row.sNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'sNumber', value);

                                                if (value && !/^\d{9,11}$/.test(value)) {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`startNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                if (row.sNumber && !/^\d{9,11}$/.test(row.sNumber)) {
                                                    toast.error('Number must be exactly 9-11 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `startNumber-${row.id}` && (
                                            <div className="hover-description">Enter a 9-11 digits number.</div>
                                        )}
                                    </td>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`endNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`endNumber-${row.id}`}
                                            value={row.eNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'eNumber', value);

                                                if (value && !/^\d{9,11}$/.test(value)) {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`endNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                if (row.eNumber && !/^\d{9,11}$/.test(row.eNumber)) {
                                                    toast.error('Number must be exactly 9-11 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `endNumber-${row.id}` && (
                                            <div className="hover-description">Enter a 9-11 digits number.</div>
                                        )}
                                    </td>

                                    <td>
                                        <select
                                            id={`numTypeRange-${row.id}`}
                                            value={row.numTypeRange}
                                            onChange={(e) => handleChange_tableRange(row.id, 'numTypeRange', e.target.value)}
                                            className={`inputbox ${validationStates[`numTypeRange-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                if ((row.sNumber || row.eNumber) && !row.numTypeRange) {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`numTypeRange-${row.id}`]: false,
                                                    }));
                                                    toast.error('Number Type is required when numbers are entered.');
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`numTypeRange-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                        >
                                            <option value=""></option>
                                            <option value="Geographical">Geographical</option>
                                            <option value="Nomadic">Nomadic</option>
                                        </select>
                                    </td>

                                    <td>
                                        {tableDataRange.length > 1 && (
                                            <button onClick={() => removeRow_range(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <button onClick={addRow_range}>Add Row</button>

                    <br></br>

                </Container>

                <br></br><br></br>

                <Container>

                    <p>If you are doing a full-port, you need to include the Leading Telephone Number or Main Billing Telephone Number in the list. If you are doing a partial-port, leave the Leading Telephone Number or Main Billing Telephone Number out of this list.</p>

                    <h2 className='heading'>Identification of the current AND losing Operator (DONOR)</h2> <br></br>

                    <Row>
                        <Col>
                            <label>Operator Name</label> <br />
                            <input
                                onChange={(e) => setOperator(e.target.value)}
                                type="text"
                                id='operator'
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>

                        <Col>
                            <label>Address</label>
                            <input
                                onChange={(e) => setAddress(e.target.value)}
                                type="text"
                                id="address"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('accNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Account Number / Reference</label>
                            <input
                                onChange={(e) => setAccNum(e.target.value)}
                                type="text"
                                id="accNum"
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'accNum' && (
                                <div className="hover-description">
                                    Account Number / Reference (as see on current bill)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('mobNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Main Billing Telephone Number (MBN)</label>
                            <input
                                type="text"
                                id="mobNum"
                                value={mobNum}
                                placeholder=""
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setMobNum(value);

                                    // Real-time validation: only allow numeric or empty (optional)
                                    if (value !== '' && !/^\d+$/.test(value)) {
                                        setValidationStates(prev => ({
                                            ...prev,
                                            mobNum: false,
                                        }));
                                    } else {
                                        setValidationStates(prev => ({
                                            ...prev,
                                            mobNum: true,
                                        }));
                                    }
                                }}
                                className={`inputbox ${validationStates.mobNum === false && mobNum !== '' ? 'error' : ''}`}
                                onBlur={() => {
                                    // Show toast if invalid and not empty
                                    if (mobNum !== '' && !/^\d+$/.test(mobNum)) {
                                        toast.error('MBN must be a numeric value.');
                                        setValidationStates(prev => ({
                                            ...prev,
                                            mobNum: false,
                                        }));
                                    }
                                }}
                            />

                            {/* Error Message */}
                            {validationStates.mobNum === false && mobNum !== '' && (
                                <div className="error-message" style={{ color: 'red' }}>Field should be a numeric value</div>
                            )}

                            {/* Tooltip */}
                            {hoveredField === 'mobNum' && (
                                <div className="hover-description">
                                    The main billing telephone number (MBN) / Leading Telephone Number.
                                    The MBN field is a number that is assimilated to a phone number.
                                </div>
                            )}
                        </Col>



                        <Col
                            onMouseEnter={() => handleMouseEnter('operatorCode')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Operator Code</label>
                            <input
                                onChange={(e) => setOperatorCode(e.target.value)}
                                type="text"
                                id="operatorCode"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <p>I release any third party from liability for acting in accordance with these instructions.

                    I acknowledge to be fully liable for the accuracy of the information herein contained and undertake to pay any and all charges incurred by this porting request.<br></br><br></br>

                    <strong>Understood and Agreed:</strong></p>

                <h2 className='heading'>Client Details</h2> <br></br>

                <Container>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('companyName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Company Name*</label> <br />
                            <input
                                onChange={(e) => setCompanyName(e.target.value)}
                                type="text"
                                id='companyName'
                                placeholder=""
                                className={`inputbox ${validationStates.companyName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('companyName', /[a-zA-Z0-9]/)}
                            />
                        </Col>

                        <Col>
                            <label>Contact Name (please print)</label> <br />
                            <input
                                onChange={(e) => setContactName(e.target.value)}
                                type="text"
                                id='contactName'
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('vatNum')}
                            onMouseLeave={handleMouseLeave}
                            xs={3}
                        >
                            <label>VAT Number*</label> <br />
                            <input
                                onChange={(e) => setVatNum(e.target.value)}
                                type="text"
                                id='vatNum'
                                placeholder=""
                                className={`inputbox ${validationStates.vatNum === false ? 'error' : ''}`}
                                onBlur={() => validateInput('vatNum', /[a-zA-Z0-9]/)}
                            />
                        </Col>

                        <Col>
                            <label>Chamber of Commerce Number, or, Other National Registration Number</label> <br />
                            <input
                                onChange={(e) => setRegNum(e.target.value)}
                                type="text"
                                id='regNum'
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>
                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('clientAddress')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Address*</label> <br />
                            <input
                                onChange={(e) => setClientAddress(e.target.value)}
                                type="text"
                                id='clientAddress'
                                placeholder=""
                                className={`inputbox ${validationStates.clientAddress === false ? 'error' : ''}`}
                                onBlur={() => validateInput('clientAddress', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'clientAddress' && (
                                <div className="hover-description">
                                    Should be Sweden.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('city')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>City*</label> <br />
                            <input
                                onChange={(e) => setCity(e.target.value)}
                                type="text"
                                id='city'
                                placeholder=""
                                className={`inputbox ${validationStates.city === false ? 'error' : ''}`}
                                onBlur={() => validateInput('city', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'city' && (
                                <div className="hover-description">
                                    Should be Sweden.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('state')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>State</label> <br />
                            <input
                                onChange={(e) => setState(e.target.value)}
                                type="text"
                                id='state'
                                placeholder=""
                                className={`inputbox`}
                            //onBlur={() => validateInput('state', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'state' && (
                                <div className="hover-description">
                                    Should be Sweden.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('zip')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Zip*</label> <br />
                            <input
                                onChange={(e) => setZip(e.target.value)}
                                type="text"
                                id='zip'
                                placeholder=""
                                className={`inputbox ${validationStates.zip === false ? 'error' : ''}`}
                                onBlur={() => validateInput('zip', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'zip' && (
                                <div className="hover-description">
                                    Should be Sweden.
                                </div>
                            )}
                        </Col>

                        <Col>
                            <label>Date of signature</label> <br />
                            <input
                                onChange={(e) => setDateSign(e.target.value)}
                                type="date"
                                id="dateSign"
                                value={dateSign}
                                className={`inputbox`}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                            />
                        </Col>

                    </Row>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    {/* <Button variant="primary" type="autofill" onClick={autofill}>Autofill</Button> */}
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default Sweden;